'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCategoryLandingPageSearchQuery = exports.getDeletedItemTitleIfNeeded = exports.searchPromoted = exports.getPromotedItems = exports.getPromotedSearchResults = exports.LOAD_PROMOTED_SEARCH_RESULTS_SUCCESS = exports.LOAD_PROMOTED_SEARCH_RESULTS_REQUEST = exports.LOAD_PROMOTED_SEARCH_RESULTS_FAIL = exports.CLEAR_PROMOTED_SEARCH_RESULTS = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.default = reducer;

var _api = require('../api');

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = require('reselect');

var _config = require('./config');

var _item = require('./item');

var _cardData = require('./cardData');

var _searchExclusions = require('./searchExclusions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var CLEAR_PROMOTED_SEARCH_RESULTS = exports.CLEAR_PROMOTED_SEARCH_RESULTS = 'CLEAR_PROMOTED_SEARCH_RESULTS';
var LOAD_PROMOTED_SEARCH_RESULTS_FAIL = exports.LOAD_PROMOTED_SEARCH_RESULTS_FAIL = 'LOAD_PROMOTED_SEARCH_RESULTS_FAIL';
var LOAD_PROMOTED_SEARCH_RESULTS_REQUEST = exports.LOAD_PROMOTED_SEARCH_RESULTS_REQUEST = 'LOAD_PROMOTED_SEARCH_RESULTS_REQUEST';
var LOAD_PROMOTED_SEARCH_RESULTS_SUCCESS = exports.LOAD_PROMOTED_SEARCH_RESULTS_SUCCESS = 'LOAD_PROMOTED_SEARCH_RESULTS_SUCCESS';

// reducer
var DEFAULT_STATE = {
    itemIDs: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case CLEAR_PROMOTED_SEARCH_RESULTS:
        case LOAD_PROMOTED_SEARCH_RESULTS_SUCCESS:
            return (0, _extends4.default)({}, state, {
                itemIDs: action.payload.itemIDs
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.searchPromoted;
};

var getPromotedSearchResults = exports.getPromotedSearchResults = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.itemIDs || [];
});

var getPromotedItems = exports.getPromotedItems = function getPromotedItems(state) {
    var itemIDs = getPromotedSearchResults(state);
    return (0, _cardData.getItemCardDatas)(state, itemIDs);
};

/* ACTION CREATORS */
var promotedSearchResultsFail = function promotedSearchResultsFail(searchQuery, error) {
    return {
        error: true,
        meta: { searchQuery: searchQuery },
        payload: error,
        type: LOAD_PROMOTED_SEARCH_RESULTS_FAIL
    };
};

var promotedSearchResultsRequest = function promotedSearchResultsRequest(searchQuery) {
    return {
        payload: searchQuery,
        type: LOAD_PROMOTED_SEARCH_RESULTS_REQUEST
    };
};

var promotedSearchResultsSuccess = function promotedSearchResultsSuccess(results) {
    return {
        payload: results,
        type: LOAD_PROMOTED_SEARCH_RESULTS_SUCCESS
    };
};

var clearPromotedSearchResults = function clearPromotedSearchResults() {
    return {
        payload: { itemIDs: [] },
        type: CLEAR_PROMOTED_SEARCH_RESULTS
    };
};

var searchPromoted = exports.searchPromoted = function searchPromoted(_ref) {
    var ids = _ref.ids,
        searchQuery = _ref.searchQuery,
        pageName = _ref.pageName;

    return function (dispatch, getState) {
        var state = getState();
        var deployment = (0, _config.getDeployment)(state);
        if (pageName === 'price-guide' || pageName === 'sold-search') {
            dispatch(clearPromotedSearchResults());
            return;
        }
        dispatch(promotedSearchResultsRequest(searchQuery));

        // Annotate facets which have user-defined search exclusions
        var searchExclusions = (0, _searchExclusions.getUserExcludedFacets)(state);
        var augmentedOptions = !searchExclusions ? searchQuery.options : (0, _keys2.default)(searchExclusions).reduce(function (options, facetWithExclusions) {
            return (0, _extends4.default)({}, options, (0, _defineProperty3.default)({}, facetWithExclusions, [{
                exclude: searchExclusions[facetWithExclusions] || [],
                include: searchQuery.options && searchQuery.options[facetWithExclusions] || []
            }]));
        }, (0, _extends4.default)({}, searchQuery.options));
        var augmentedSearchQuery = (0, _extends4.default)({}, searchQuery, {
            options: augmentedOptions
        });

        return _api.Search.fetchPromotedSearchResults({ deployment: deployment, ids: ids, searchQuery: augmentedSearchQuery }).then(function (results) {
            if (results.errorMessage) {
                dispatch(promotedSearchResultsFail(searchQuery, results));
                dispatch(clearPromotedSearchResults());
            } else {
                dispatch(promotedSearchResultsSuccess(results));
            }
        }).catch(function (error) {
            dispatch(promotedSearchResultsFail(searchQuery, error));
            dispatch(clearPromotedSearchResults());
        });
    };
};

var getDeletedItemTitleIfNeeded = exports.getDeletedItemTitleIfNeeded = function getDeletedItemTitleIfNeeded(state, query) {
    var item = void 0;
    var returnTitle = '';
    if (query.deleted && !isNaN(query.deleted)) {
        item = (0, _item.getItem)(state, query.deleted) || {
            isDeleted: true,
            title: 'The item you were seeking'
        };
    }
    if (item && item.isDeleted && item.title) {
        returnTitle = item.title;
    }
    return returnTitle;
};

var getCategoryLandingPageSearchQuery = exports.getCategoryLandingPageSearchQuery = function getCategoryLandingPageSearchQuery(pathname, savedSearchQuery) {
    var result = (0, _cloneDeep2.default)(savedSearchQuery);

    if (pathname.includes('/c/') && !result.campaignId) {
        var pathCategoryIds = pathname.match(/\d+/g);
        pathCategoryIds = pathCategoryIds ? pathCategoryIds.join() : '';
        var category_id = savedSearchQuery.category_id;


        if (!category_id) {
            result.category_id = pathCategoryIds;
        } else {
            result.category_id = pathCategoryIds + ',' + savedSearchQuery.category_id;
        }
    }

    return result;
};

//TODO: rename all the categories to landing where appropriate


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/searchPromoted.js
// module id = EjXQ
// module chunks = 60